import state from "./state";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import visualizacao from "./visualizacao";

/**
 * Módulo Vuex "relatoOcorrencia" (namespaced).
 * Centraliza filtros, paginação e loading da listagem de relatos.
 */
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,

  modules: {
    visualizacao
  }
};
